import * as React from 'react';
import { autobind } from 'office-ui-fabric-react/lib/Utilities';
import { SharingAudience, SharingRole, ISharingLinkSettings, ClientId } from '../../../../interfaces/SharingInterfaces';
import { RoleSelector } from '../../../RoleSelector/RoleSelector';
import strings from '../../../Share.resx';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost, DirectionalHint } from 'office-ui-fabric-react/lib/Tooltip';

export interface IIconData {
    name: string;
    title: string;
}

export interface IChangePermissionProps {
    onRoleChange: (value: SharingRole) => void;
    selectedPermissions: ISharingLinkSettings;
    clientId: ClientId;
    appmap?: string;
}

export interface IChangePermissionState {
    selectedKey: SharingRole;
}

export class ChangePermission extends React.Component<IChangePermissionProps, IChangePermissionState> {

    constructor(props: IChangePermissionProps, context: any) {
        super(props);

        this.state = {
            selectedKey: this._getSelectedKey(props)
        };
    }

    public render(): React.ReactElement<{}> {
        const props = this.props;
        const linkAudience = props.selectedPermissions.audience;

        return (
            <RoleSelector
                disabled={ linkAudience !== SharingAudience.specificPeopleFlex }
                role={ this.state.selectedKey }
                onRoleChange={ this._onAllowRoleChange }
                clientId={ props.clientId }
                appmap={ props.appmap }
            >
                { linkAudience !== SharingAudience.specificPeopleFlex && this._renderInfoIcon() }
            </RoleSelector>
        );
    }

    @autobind
    private _onAllowRoleChange(role: SharingRole): void {
        this.setState({
            selectedKey: role
        }, () => {
            this.props.onRoleChange(role);
        });
    }

    private _getSelectedKey(props: IChangePermissionProps): SharingRole {
        let selectedKey: SharingRole;

        if (!props.selectedPermissions.sharingRole) {
            if (props.selectedPermissions.isEdit) {
                selectedKey = SharingRole.edit;
            } else {
                selectedKey = SharingRole.view;
            }
        } else {
            selectedKey = props.selectedPermissions.sharingRole;
        }

        return selectedKey;
    }

    private _renderInfoIcon() {
        return (
            <div className='od-changePermissions--info' aria-label={ strings.createNewLinkTooltip } aria-haspopup={ true }>
                <TooltipHost
                    id={ 'od-changePermissions--tooltip' }
                    content={ strings.createNewLinkTooltip }
                    directionalHint={ DirectionalHint.topLeftEdge }
                    calloutProps={ { gapSpace: 0 } }
                    tooltipProps={ { maxWidth: '320px' } }
                >
                    <Icon iconName='Info' data-is-focusable={ true } aria-describedby={ 'od-changePermissions--tooltip' } />
                </TooltipHost>
            </div>
        );
    }
}